// src/pages/Home/PartenairesCarousel.jsx
import React, { useState, useEffect } from "react";
import { getAllPartenaires } from "../../services/partenairesServices";

const PartenairesCarousel = () => {
  const [partenaires, setPartenaires] = useState([]);

  useEffect(() => {
    const fetchPartenaires = async () => {
      try {
        const allPartenaires = await getAllPartenaires();
        const activePartenaires = (allPartenaires || []).filter(
          (p) => p.is_active
        );
        setPartenaires(activePartenaires);
      } catch (error) {
        console.error("Erreur lors de la récupération des partenaires", error);
      }
    };

    fetchPartenaires();
  }, []);

  if (!partenaires.length) {
    return null; // Rien à afficher si pas de partenaires
  }

  return (
    <section className="py-10 md:py-14 bg-slate-50 dark:bg-slate-900">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Titre */}
        <div className="flex flex-col items-center text-center mb-6 md:mb-8">
          <p className="text-xs font-semibold tracking-[0.3em] uppercase text-primary mb-1">
            Partenaires
          </p>
          <h2 className="text-2xl md:text-3xl font-extrabold tracking-tight">
            Nos partenaires du comité
          </h2>
          <p className="mt-2 text-xs md:text-sm text-slate-600 dark:text-slate-400 max-w-xl">
            Clubs, institutions et partenaires privés qui soutiennent le Judo
            girondin et les actions du comité.
          </p>
        </div>

        {/* Grille : 3 colonnes minimum en mobile */}
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-3 md:gap-4">
          {partenaires.map((partenaire) => {
            const cardContent = (
              <div className="group relative rounded-xl bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700/80 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-200 flex flex-col items-center justify-between px-2.5 py-3 md:px-3 md:py-4">
                {/* Logo */}
                <div className="w-full aspect-[4/3] flex items-center justify-center overflow-hidden">
                  <img
                    src={partenaire.photo_url}
                    alt={partenaire.nom}
                    className="max-h-12 md:max-h-16 w-auto object-contain transition-transform duration-300 group-hover:scale-110"
                  />
                </div>

                {/* Nom */}
                <p className="mt-2 text-[10px] sm:text-xs md:text-sm text-center font-medium text-slate-700 dark:text-slate-200 line-clamp-2">
                  {partenaire.nom}
                </p>

                {/* Label hover */}
                <span className="mt-1 inline-flex items-center rounded-full bg-primary/5 text-primary/80 text-[9px] sm:text-[10px] px-2 py-0.5 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  Visiter le site
                </span>
              </div>
            );

            // Si un lien de site est présent, on wrap dans <a>, sinon simple <div>
            return partenaire.link_url ? (
              <a
                key={partenaire.id}
                href={partenaire.link_url}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                {cardContent}
              </a>
            ) : (
              <div key={partenaire.id}>{cardContent}</div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PartenairesCarousel;
